import {
    LocaleResolutionError,
    LocaleErrorSource,
    LocaleRouteType,
} from '../errors/locale-resolution.error';

export enum LocaleErrorAction {
    NotFound = 'NOT_FOUND',
    Fallback = 'FALLBACK',
}

export class LocaleErrorActionService {
    public resolve(error: unknown): LocaleErrorAction {
        if (!(error instanceof LocaleResolutionError)) {
            return LocaleErrorAction.Fallback;
        }

        if (
            error.source === LocaleErrorSource.Url &&
            error.routeType === LocaleRouteType.Indexable
        ) {
            return LocaleErrorAction.NotFound;
        }

        return LocaleErrorAction.Fallback;
    }
}
